import { render, staticRenderFns } from "./NovaLicao.vue?vue&type=template&id=480c2510&"
import script from "./NovaLicao.vue?vue&type=script&lang=js&"
export * from "./NovaLicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports